import React, { FC } from "react";
import EditIcon from "../../../assets/EditIcon";
import {
  Company,
  ICategory,
  ISubCategory,
  ITransaction,
  User,
} from "../../../interfaces";
import "./style.scss";
import tvaEditIcon from "../../assets/images/svg/edit-small-blue.svg";
import { IoMdCreate } from "react-icons/io";

export type ImmobStateHandler = {
  isImmobFire: boolean;
  setIsImmobFire: any;
  isImmobSubCateg: ISubCategory | null;
  setIsImmobSubCateg: any;
  isImmobTrans: ITransaction | null;
  setIsImmobTrans: any;
} | null;

type TabsProps = {
  tabs: {
    label?: string;
    image?: string | null;
    index: number;
    activated: boolean;
    Component: FC<{
      index: number;
      context?: string;
      company?: Company | {};
      client?: User | {};
      callback?: any;
      reload?: boolean;
      immobStateHandler?: ImmobStateHandler;
    }>;
  }[];
  selectedTab: number;
  onClick: (index: number) => void;
  orientation?: "horizontal" | "vertical";
  className?: string;
  context?: string;
  company?: Company;
  client?: User;
  callback?: any;
  reload?: boolean;
  immobStateHandler?: ImmobStateHandler;
};

/**
 * Avalible Props
 * @param className string
 * @param tab Array of object
 * @param selectedTab number
 * @param onClick Function to set the active tab
 * @param orientation Tab orientation Vertical | Horizontal
 */
const Tabs: FC<TabsProps> = ({
  className = "tabs-component",
  tabs = [],
  selectedTab = 0,
  onClick,
  orientation = "horizontal",
  context = "",
  company = {},
  client = {},
  callback = null,
  reload = false,
  immobStateHandler = null,
}) => {
  const Panel = tabs && tabs.find((tab) => tab.index === selectedTab);

  return (
    <div
      className={
        orientation === "vertical" ? className + " vertical" : className
      }
    >
      <div className="tablist" role="tablist" aria-orientation={orientation}>
        {tabs.map((tab) => (
          <button
            className={`${selectedTab === tab.index ? "btn active" : " btn"} ${
              orientation === "vertical" &&
              tabs.some((elt) => elt.image) &&
              "whitelabel-edit-tab"
            }`}
            onClick={() => onClick(tab.index)}
            key={tab.index}
            type="button"
            role="tab"
            aria-selected={selectedTab === tab.index}
            aria-controls={`tabpanel-${tab.index}`}
            tabIndex={selectedTab === tab.index ? 0 : -1}
            id={`btn-${tab.index}`}
          >
            <span
              className={`app-status ${tab.activated ? "active" : "inactive"}`}
            >
              ●
            </span>
            {tab.image ? (
              <>
              <span className={`icon-tabs`}>
                <img src={tab.image} />
              
              </span>
                {orientation === "vertical" && tabs.some((elt) => elt.image) && (
                  <span
                    className="whitelabel-edit-button"
                    onClick={() => callback(tab.index)!}
                  >
                    <IoMdCreate />
                  </span>
                )}
             </>
            ) : (
              <span className={`icon-tabs`}>
                <span className="app-label">{tab.label}</span>
                {orientation === "vertical" && tabs.some((elt) => elt.image) && (
                  <span
                  className="whitelabel-edit-button-empty"
                  onClick={() => callback(tab.index)!}
                  >
                    <IoMdCreate />
                  </span>
                )}
              </span>
            )}
          </button>
        ))}
      </div>
      <div
        role="tabpanel"
        aria-labelledby={`btn-${selectedTab}`}
        id={`tabpanel-${selectedTab}`}
        className="tabpanel"
      >
        {Panel && (
          <Panel.Component
            index={selectedTab}
            context={context}
            company={company}
            client={client}
            callback={callback}
            reload={reload}
            immobStateHandler={immobStateHandler}
          />
        )}
      </div>
    </div>
  );
};
export default Tabs;
